import { OnboardingBanner, GPTBanner } from 'components/opportunity-page';
import { useAuth } from 'lib/providers/AuthProvider';
import { useOpportunity } from 'lib/providers/OpportunityProvider';
import { TouchpointType } from 'lib/models/touchpoint';

export const OpportunityBanner = ({ className }: { className?: string }) => {
  const { isCandidate, isInitialAuthLoading } = useAuth();
  const { opportunity, isOpportunityAppliedOrUnappliable, isOpportunityPublicPage } = useOpportunity();
  const { touchpointable_type, apply_url, creatable_for } = opportunity;
  const isJobOrInternship = touchpointable_type === TouchpointType.Job || touchpointable_type === TouchpointType.Internship;
  const isEvent = touchpointable_type === TouchpointType.Event;
  const isExternalEventByCompany = isEvent && apply_url && creatable_for.data.type === 'company';

  if (!isOpportunityPublicPage || isInitialAuthLoading || isOpportunityAppliedOrUnappliable) {
    return null;
  }

  return isCandidate ? (
    isJobOrInternship || isExternalEventByCompany ? (
      <GPTBanner className={className} />
    ) : null
  ) : apply_url && isJobOrInternship ? (
    <OnboardingBanner className={className} />
  ) : null;
};

OpportunityBanner.displayName = 'OpportunityBanner';
